/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import _ from 'lodash';

export const Dropdown = BaseControl.extend({
    init: function(element, options) {
        this.data = this.options.data;
        this.selectFirstDropdownItem();
        this._super(element, options);
    },

    selectFirstDropdownItem: function() {
        if (
            this.data.dropdown &&
            this.data.customData &&
            _.isArray(this.data.customData.items)
        ) {
            var firstDropdownItem = _.first(this.data.customData.items);
            if (firstDropdownItem) {
                this.$element
                    .find('.current-item')
                    .text(firstDropdownItem.text);
            }
        }
    },

    '.dropdown .item click': function($el) {
        this.$element.find('.current-item').text($el.text());
        this.$element.find('.b-dropdown').removeClass('hover');
    },

    '.b-dropdown mouseenter': function() {
        this.selectFirstDropdownItem();
    },

    '.current-item touchstart': function($el) {
        var $pageDropdown = $el.parent();
        if ($pageDropdown.hasClass('hover')) {
            $pageDropdown.removeClass('hover');
        } else {
            $pageDropdown.addClass('hover');
            this.selectFirstDropdownItem();
        }
    },

    '{window} click': function($el, context) {
        if (!this.$(context.toElement).parents('.b-dropdown').length) {
            this.$element.find('.b-dropdown').removeClass('hover');
        }
    },
});
